enum FamilleControleCoherence {
	EQUILIBRE_BUDGETAIRE = 0,
	OPERATIONS_ORDRE = 1,
	AUTRES = 2,
}

export default FamilleControleCoherence;
